/*
	アコーディオン
 */
$(function(){
	$accordionBtn = $('.js-menuOpen');
	if($accordionBtn.length){
		$accordionBtn.on('click', function(){
			console.log(this);
			if($(this).hasClass('-open')){
				// open -> close
				$(this)
					.removeClass('-open')
					.next()
					.slideUp(200);
			}else {
				// close -> open
				$(this)
					.addClass('-open')
					.next()
					.slideDown(200);
			}
		})
	}
});
